<script lang="ts" setup>
import { type TitleWithText } from '@/utils/types/Object'
const props = defineProps({
  data: {
    type: Object
  },
  subtitle: {
    type: String
  },
  h1: {
    type: Boolean,
    default: false
  }
})

// const propsData = reactive(props.data!) as TitleWithText
const propsData = computed<TitleWithText>(() => props.data as TitleWithText)

const isShow: Ref<boolean> = ref(false)

onMounted(() => {
  setTimeout(() => {
    isShow.value = true
  }, 100)
})
</script>

<template>
  <div class="intro" :class="{ isShow: isShow }">
    <div class="intro__subtitle">{{ props.subtitle }}</div>
    <h1 class="intro__title" v-if="h1">{{ propsData.title }}</h1>
    <div class="intro__title" v-else>{{ propsData.title }}</div>
    <div class="intro__text" v-if="propsData.text" v-html="propsData.text"></div>
  </div>
</template>

<style lang="scss" scoped>
.intro {
  text-align: center;

  &.align-left {
    text-align: left;
  }

  &__subtitle,
  &__title,
  &__text {
    opacity: 0;
    transform: translateY(30px);
    transition: all 0.8s ease-in-out;
  }

  &.isShow {
    .intro {

      &__subtitle,
      &__title,
      &__text {
        transform: translateY(0);
        opacity: 1;
      }

      &__subtitle {
        transition-delay: 0.1s;
      }

      &__title {
        transition-delay: 0.2s;
      }

      &__text {
        transition-delay: 0.3s;
      }
    }
  }

  &__subtitle {
    font-size: toRem(130);
    font-family: $font-TextaAlt;
    font-weight: 500;
    color: $color-gray-3;
    line-height: 1;

    @include max-media(640) {
      font-size: toRem(60);
    }

    @include max-media(380) {
      font-size: toRem(48);
    }
  }

  &__title {
    margin-bottom: toRem(22);
    font-size: toRem(28);
    font-weight: 500;
  }

  &__text {
    margin-bottom: toRem(30);
    font-size: toRem(22);
    font-weight: 500;
  }

  &.brand3 {
    .intro {
      &__subtitle {
        color: $color-brand-3;
      }
    }
  }

  &.dark {
    .intro {
      &__subtitle {
        color: $color-black-1;
      }

      &__title {
        color: $color-black-1;
      }
    }
  }

  &.white {
    .intro {
      &__subtitle {
        color: $color-white-2;
      }

      &__title {
        color: $color-white-2;
      }
    }
  }

  &.display80 {
    .intro {
      &__subtitle {
        margin-bottom: toRem(10);
        font-size: toRem(80);
        line-height: 0.8;
        letter-spacing: toRem(-1.6);

        @include max-media(767) {
          font-size: toRem(60);
        }
      }

      &__title {
        @include max-media(767) {
          font-size: toRem(22);
        }
      }
    }
  }

  &.display110 {
    .intro {
      &__subtitle {
        margin-bottom: toRem(24);
        font-size: toRem(110);
        font-size: 7.7vw;
        font-weight: 500;
        line-height: 0.8;
        letter-spacing: toRem(-2.2);

        @include max-media(900) {
          font-size: toRem(80);
        }
      }
    }
  }

  &.display158 {
    .intro {
      &__subtitle {
        margin-bottom: toRem(10);
        font-size: toRem(158);
        font-size: 11vw;
        line-height: 0.8;
        letter-spacing: toRem(-3.16);

        @include max-media(640) {
          font-size: toRem(80);
        }
      }
    }
  }
}
</style>
